module.exports = __webpack_public_path__ + "img/army-logo.c93ed621.jpg";